"use client";
import { useEffect } from "react";
import axios from "axios";
import { AppDispatch, AppState } from "@/store/configureStore";
import { updateUser } from "@/store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_USER_INFO_API } from "@/constants";

const useFetchUser = () => {
	const dispatch = useDispatch<AppDispatch>();
	const user = useSelector((state: AppState) => state.user);
	// const base_url = process.env.NEXT_PUBLIC_BASE_URL

	useEffect(() => {
		const fetchUserInfo = async () => {
			try {
				const response = await axios.get(FETCH_USER_INFO_API, {
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				});
				// console.log(response?.data)
				// dispatch(updateUser({
				// 	...user,
				// 	name: response?.data?.user?.fullName,
				// 	email: response?.data?.user?.email,
				// 	dateOfBirth: response?.data?.user?.dateOfBirth,
				// 	phoneNumber: response?.data?.user?.phoneNumber,
				// }))
			} catch (error: string | any) {
				// console.log(`API Error: ${error}`);
			}
		};
		fetchUserInfo();
	}, [dispatch, user]);
};
export default useFetchUser;
